import React from "react";
import "./About.scss"
import {Link} from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import {ABOUT} from "../helper/constant";

const About = () => {
    return (
        <>
            <div className={'goBack'}><Link to={'/'}><HomeIcon className={'back'}/></Link></div>
            <div className={'aboutContainer'}>
                <div className={'leftContainer'}>
                    <div className={'education'}>
                        <h1>{ABOUT.EDUCATION}</h1>
                        <h2>{ABOUT.PROGRAM}</h2>
                        <h3>{ABOUT.NAME}</h3>
                        <div className={'skillSet'}>
                            <div>{ABOUT.SKILL}</div>
                        </div>
                        <div className={'qualification'}>
                            <h3>{ABOUT.QUALIFICATION}</h3>
                            <div>{ABOUT.DETAILS}</div>
                        </div>
                        <div className={'summary'}>
                            <div>{ABOUT.SUM}</div>
                        </div>
                    </div>
                </div>


            </div>

        </>
    )

}


export default About
